import { VisuallyHidden } from '@radix-ui/react-visually-hidden'

import Text from '../../../components/Typography/Text'

import Modal from './Modal'

type Props = {
  cancelText?: string
  children: React.ReactNode
  confirmText?: string
  isDestructive?: boolean
  isLoading?: boolean
  onCancel: () => void
  onConfirm: (() => void) | (() => Promise<unknown>)
  /**
   * Customize which element receives focus when the modal closes; by default it is the element that triggered the modal, but you will need to set this if the trigger no longer exists (e.g. a menu item)
   */
  onCloseFocusRef?: React.RefObject<HTMLElement>
}
const ConfirmationModal = ({
  cancelText,
  children,
  confirmText,
  isDestructive,
  isLoading,
  onCancel,
  onConfirm,
  onCloseFocusRef,
}: Props) => {
  return (
    <Modal onClose={onCancel} onCloseFocusRef={onCloseFocusRef}>
      <VisuallyHidden>
        {/* Dialogs need a screen-readable header to be accessible */}
        <Modal.Header>Are you sure?</Modal.Header>
      </VisuallyHidden>
      <Modal.Content>
        {typeof children === 'string' ? <Text>{children}</Text> : children}
      </Modal.Content>
      <Modal.Footer
        cancelText={cancelText}
        confirmText={confirmText}
        isDestructive={isDestructive}
        onCancel={onCancel}
        onConfirm={onConfirm}
        isLoading={isLoading}
      />
    </Modal>
  )
}

export default React.memo(ConfirmationModal)
